import { apiUrl, fetchJson } from '../../apiBase';

export async function fetchLibraryClaims(schoolId, classId) {
  const suffix = classId ? `?class_id=${encodeURIComponent(classId)}` : '';
  const res = await fetchJson(apiUrl(`/admin/library/${encodeURIComponent(schoolId)}/claims${suffix}`));
  if (!res.ok) throw new Error('Onay bekleyen kitaplar yüklenemedi.');
  return res.json();
}

export async function reviewLibraryClaim(schoolId, claimId, action, corrections) {
  const res = await fetchJson(apiUrl(`/admin/library/${encodeURIComponent(schoolId)}/claims/${encodeURIComponent(claimId)}/${action}`), {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corrections || {}),
  });
  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    const error = new Error(typeof payload.detail === 'string' ? payload.detail : 'İşlem tamamlanamadı.');
    error.status = res.status;
    throw error;
  }
  return res.json();
}

export async function fetchLibraryPointEvents(schoolId, classId, after) {
  const params = new URLSearchParams({ class_id: String(classId) });
  if (after !== null && after !== undefined) params.set('after', String(after));
  const res = await fetchJson(apiUrl(`/admin/library/${encodeURIComponent(schoolId)}/point-events?${params}`));
  if (!res.ok) throw new Error('Puan etkinlikleri yüklenemedi.');
  return res.json();
}

export async function fetchLibraryBoard(schoolId, { period, className } = {}) {
  const params = new URLSearchParams();
  if (period) params.set('period', String(period));
  if (className) params.set('class_name', String(className));
  const suffix = params.toString() ? `?${params.toString()}` : '';
  const res = await fetchJson(apiUrl(`/admin/library/${encodeURIComponent(schoolId)}/board${suffix}`));
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function fetchLibraryStudentStatistics(schoolId, { className, period } = {}) {
  const params = new URLSearchParams();
  if (className) params.set('class_name', String(className));
  if (period) params.set('period', String(period));
  const suffix = params.toString() ? `?${params.toString()}` : '';
  const res = await fetchJson(apiUrl(`/admin/library/${encodeURIComponent(schoolId)}/student-statistics${suffix}`));
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function fetchLibraryBooks(schoolId, { grade } = {}) {
  const params = new URLSearchParams();
  if (grade) params.set('grade', String(grade));
  const suffix = params.toString() ? `?${params.toString()}` : '';
  const res = await fetchJson(apiUrl(`/admin/books/${encodeURIComponent(schoolId)}${suffix}`));
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function fetchLibraryClassStudents(schoolId, classId) {
  const res = await fetchJson(
    apiUrl(`/admin/students/${encodeURIComponent(schoolId)}/by-class/${encodeURIComponent(classId)}`),
  );
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function markLibraryCompletedBook(schoolId, { studentId, bookId, finishedDate } = {}) {
  const res = await fetchJson(
    apiUrl(`/admin/library/${encodeURIComponent(schoolId)}/completed-book`),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        student_id: Number(studentId),
        book_id: Number(bookId),
        ...(finishedDate ? { finished_date: String(finishedDate) } : {}),
      }),
    },
  );
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function unmarkLibraryCompletedBook(schoolId, { studentId, bookId } = {}) {
  const res = await fetchJson(
    apiUrl(`/admin/library/${encodeURIComponent(schoolId)}/completed-book/unmark`),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        student_id: Number(studentId),
        book_id: Number(bookId),
      }),
    },
  );
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function markLibraryCompletedBookBulk(schoolId, { studentIds, bookId, finishedDate } = {}) {
  const res = await fetchJson(
    apiUrl(`/admin/library/${encodeURIComponent(schoolId)}/completed-book/bulk`),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        student_ids: Array.isArray(studentIds) ? studentIds.map((id) => Number(id)) : [],
        book_id: Number(bookId),
        ...(finishedDate ? { finished_date: String(finishedDate) } : {}),
      }),
    },
  );
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

